import { SimpleText } from 'platform-components';
import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ym from 'react-yandex-metrika';

import { ConfirmationDialog } from 'common.components/confirmation-dialog/confirmation-dialog';
import { getCurrentYearCourseId } from 'common.components/course/selectors';
import { subscriptionModalActions } from 'common.components/lesson-view.subscription-modal/actions';
import * as selectors from 'common.components/lesson-view.subscription-modal/selectors';
import * as lessonSelectors from 'common.components/lesson/selectors';

interface Props {
    commonMetrikaData: Record<string, any>;
    opened: boolean;
}

export const SubscriptionModalModeUnsubscribe = (props: Props) => {
    const dispatch = useDispatch();
    const { commonMetrikaData, opened } = props;
    const currentCourseId = useSelector(getCurrentYearCourseId);
    const subscriptionSlug = useSelector((store) =>
        lessonSelectors.getLessonActiveSubscriptionSlug(store, { courseId: currentCourseId })
    );
    const subscription = useSelector((store) =>
        lessonSelectors.getSubscriptionBySlug(store, { slug: subscriptionSlug })
    );
    const isLoading = useSelector((store) => selectors.getIsLoading(store, { slug: subscriptionSlug }));

    useEffect(() => {
        if (opened) {
            ym('reachGoal', ' subscription_cancel_pop_up', {
                action_type: 'show',
                subcription_slug: subscriptionSlug,
                ...commonMetrikaData,
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [opened]);

    const cancelSubscription = (isClose: boolean) => {
        dispatch(subscriptionModalActions.cancelSubscription());
        ym('reachGoal', 'subscription_cancel_pop_up', {
            action_type: isClose ? 'close' : 'skip',
            subcription_slug: subscriptionSlug,
            ...commonMetrikaData,
        });
    };

    const confirmUnsubscribe = useCallback(() => {
        // slug точно есть, иначе бы модалка не показалась, на всякий кидаем ошибку
        if (!subscriptionSlug) {
            throw Error('Error: trying to show subscription modal with no subscription slug');
        }
        dispatch(
            subscriptionModalActions.confirmUnsubscriptionRequest({
                slug: subscriptionSlug,
            })
        );
        ym('reachGoal', 'subscription_cancel_pop_up', {
            action_type: 'agree',
            subcription_slug: subscriptionSlug,
            ...commonMetrikaData,
        });
    }, [dispatch, subscriptionSlug, commonMetrikaData]);

    const messageId = subscription?.subscription.unsubscribe_text;

    return (
        <ConfirmationDialog
            cancelInProgress={isLoading}
            closable={true}
            confirmInProgress={isLoading}
            confirmLabelId="subscriptionModal.unsubscribe.cancel"
            headerId="subscriptionModal.title.unsubscribe"
            headerType={SimpleText.TYPE.MARKDOWN}
            messageId={messageId}
            messageType={SimpleText.TYPE.MARKDOWN}
            mix="subscription-modal"
            onClose={() => cancelSubscription(true)}
            onConfirm={() => cancelSubscription(false)}
            onReject={confirmUnsubscribe}
            opened={opened}
            rejectLabelId="subscriptionModal.unsubscribe.submit"
        />
    );
};
